module.exports = __webpack_public_path__ + "img/image2019-9-26_9-59-43.2d174648.png";